const ApiConfig = Object.freeze({
    api:'https://us-central1-virtual-sum-307700.cloudfunctions.net',

})

export default  ApiConfig;
